export default __webpack_public_path__ + "static/media/p7.06d031a3.jpg";